import { render } from "./assign_question.html?vue&type=template&id=628a4d2f&external"
import script from "./assign_question.js?vue&type=script&lang=js&external"
export * from "./assign_question.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__